import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=0a80ab70&scoped=true&"
import script from "./addEdit.vue?vue&type=script&lang=js&"
export * from "./addEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80ab70",
  null
  
)

export default component.exports